<template>
<div>
    <b-container fluid>
        <b-row>
            <b-col class="m-0 p-0">
                <form @submit.prevent="setTopic">
                    <b-overlay :show="updating" rounded="sm">
                        <b-card bg-variant="light" class="m-0 p-0">
                            <b-form-group>
                                <b-form-group class="nested-form-group" label="Select Exam Category:" label-for="category">
                                    <!-- 'chkcatarr' checks if the category Array is empty and therefore shows the overlay over this select box instead of letting users bring down an empty select box -->
                                    <b-overlay :show="chkcatarr" rounded opacity="0.6" spinner-type="grow" spinner-small spinner-variant="primary" class="w-100">
                                        <b-form-select v-model="topicObj.category" :options="Categoriesarray" @change="categoryChanged">
                                            <b-form-select-option value="null">--Select category--</b-form-select-option>
                                        </b-form-select>
                                    </b-overlay>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="sameName == 'No'" label="Select Institution" label-for="institution">
                                    <b-form-select v-model="topicObj.institution" @change="institutionChanged" :options="institutionsarray">
                                        <b-form-select-option value="null">--Select Institution--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.institution != null" label="Select Level" label-for="institution">
                                    <b-form-select v-model="topicObj.level" @change="levelChanged" :options="levelsarray">
                                        <b-form-select-option value="null">--Select Level--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Section' && topicObj.level != null" label="Select Course" label-for="institution">
                                    <b-form-select v-model="topicObj.topicfor" :options="coursesarray">
                                        <b-form-select-option value="null">--Select Course--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="structure == 'Subject' && topicObj.institution != null" label="Select Subject" label-for="institution">
                                    <b-form-select v-model="topicObj.topicfor" :options="subjectOptions">
                                        <b-form-select-option value="null">--Select Subject--</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>

                                <b-form-group class="nested-form-group" v-if="topicObj.topicfor != null" label="Input in Topic" label-for="institution">
                                    <b-form-input type="text" v-model="topicObj.topic" @focus="updated = false"></b-form-input>
                                </b-form-group>
                                <div v-if="updated" class="alert alert-success p-3">
                                    Topic Updated
                                </div>

                                <div class="text-center">
                                    <b-overlay :show="updating" rounded opacity="0.6" spinner-small spinner-variant="primary" class="w-100">
                                        
                                        <b-button :disabled="!substate" type="submit" class="w-50 p-2 btnsub" variant="success" @click="proceed">
                                            Save Changes
                                        </b-button>
                                    </b-overlay>

                                    <b-button v-if="updating" class="w-50 p-2 mt-3 btntxt" variant="dark" @click="stopproceed">
                                        Cancel
                                    </b-button>
                                </div>  
                            </b-form-group>
                        </b-card>
                    </b-overlay>
                </form>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";

export default {
    components: {},
    data() {
        return {
            chkcatarr : false,
            copytext: "",
            showcopy: false,
            leaving: false,
            subjectOptions: [],
            categoryarray: [],
            levelsarray: [],
            coursesarray: [],
            scholarshiptypearray: [],
            institutionsarray: [],
            topicObj: this.getForm(),
            updating: false,
            updated: false,
            level : null,
            sameName : "",
            org : "",
            structure : ""
        };
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch("exam/retrieveInstitutions");
        store.dispatch("admin/fetchTopic");
        next();
    },
    created() {  

        if (!this.loggedin) {
            this.$router.push({
                name: "login"
            });
        }
        if (this.details.clearance == "Normal") {
            this.$router.push({
                name: "welcome"
            });
        }
        
        this.org = this.details.clearance_organization
        
        if (this.Categories.length > 0) { // If the category Array has been populated by the response from the Api
            let inst = this.allinsti.filter(x => x.available == "Yes").map(x => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

            this.institutionsarray = inst; // set the Data property institutionsarray with this value
            let typesarr = this.Categories.filter(x => x.organization_name == this.details.clearance_organization).map(x => x.name); // Get the Categories and map their names to the 'typesarray'
            this.Categoriesarray = typesarr; // set the value of the data property 'Categoriesarray' to this value
        } else {
            // If the initial API call did not send back the response on time, dispatch another request and this time wait for the request to send a response before doing any further operation
            store.dispatch("admin/fetchCategories").then(() => {
                store.dispatch("admin/fetchInstitutions");

                let inst = this.allinsti.filter(x => x.available == "Yes").map(x => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

                this.institutionsarray = inst; // set the Data property institutionsarray with this value
                let typesarr = this.Categories.map(x => x.name); // Get the Categories and map their names to the 'typesarray'
                this.Categoriesarray = typesarr; // set the value of the data property 'Categoriesarray' to this value
            });
        }


        let categoryinstitution = "";

        let tabi = this.Categories.filter(
                (x) => x.organization_name == this.org && x.name == this.topicforedit.category
            ).map((x) => x.structure);
        this.structure = tabi[0];

            

        if ( this.structure == 'Section') {
            let levell = this.allinsti.filter((x) => x.category == this.topicforedit.category && x.name == this.topicforedit.institution).map((x) => x.levels_config);
            console.log(levell)
            let reallevell = JSON.parse(levell)

            this.levelsarray = reallevell.map(x => x.name)
            categoryinstitution = this.topicforedit.institution

            // let levell = this.allinsti.filter((x) => x.category == this.topicforedit.category && x.name == this.topicforedit.institution).map((x) => x.levels_config);

            // let reallevell = JSON.parse(levell)

            // // Get the Chosen Level exact config Array
            let config = reallevell.filter(x => x.name == this.topicforedit.level).map(x => x.config)
            // Now get the Courses from the courses Object of the Chosen level exact config Object
            let courses = config[0].filter(x => x.name == "courses").map(x => x.values)

            // Inject this Array into the general courses Array for Selection
            this.coursesarray = courses[0]
        } else {
            // let subbb = this.allinsti.filter((x) => x.name == this.topicforedit.institution).map((x) => x.subjects_offered);
            // this.subjectOptions = JSON.parse(subbb);

            let sameName = this.Categories.filter(
                (x) => x.organization_name == this.org && x.name == this.topicforedit.category
            ).map((x) => x.sameName);
            this.sameName = sameName[0]

            if(this.sameName == "Yes") {
                this.topicforedit.institution = this.topicforedit.category
                let subbb = this.allinsti
                    .filter((x) => x.name == this.topicforedit.category)
                    .map((x) => x.subjects_offered);
                this.subjectOptions = JSON.parse(subbb);
            }else{
                categoryinstitution = this.topicforedit.institution;
                let subbb = this.allinsti.filter(x => x.name == this.topicforedit.institution && x.category == this.topicforedit.category ).map(x => x.subjects_offered);
                this.subjectOptions = JSON.parse(subbb);
            }
            
            
        }

        this.topicObj = {
            institution: categoryinstitution,
            category: this.topicforedit.category,
            topicfor : this.topicforedit.topic_for,
            topic: this.topicforedit.topic,
            level : this.topicforedit.level,
            trackid : this.topicforedit.track_id
        };
    },

    methods: {
        leaveRoute() {
            this.leaving = true;
            this.$bvToast.toast("Press the Back Button again to Exit", {
                noCloseButton: true,
                solid: true,
                variant: "dark",
                toaster: "b-toaster-bottom-center"
            });
        },
        stayRoute() {
            this.$bvToast.toast("Exiting Canceled", {
                noCloseButton: true,
                solid: true,
                variant: "dark",
                toaster: "b-toaster-bottom-center"
            });
        },
        categoryChanged() {
            this.topicObj.institution = null // If the type is changed, reset the select Object. set the institution property to null
            this.institutionsarray = [] // Empties the Institutions Array
            this.topicfor = null

            // let org = this.details.clearance_organization;

            let inst = this.allinsti
                .filter((x) => x.available == "Yes" && x.category == this.topicObj.category && x.organization_name == this.org)
                .map((x) => x.name);

            console.log(inst)
            this.institutionsarray = inst;

            this.topicObj.organization = this.org
            let tabi = this.Categories.filter(
                (x) => x.organization_name == this.org && x.name == this.topicObj.category
            ).map((x) => x.structure);
            this.structure = tabi[0];

            let sameName = this.Categories.filter(
                (x) => x.organization_name == this.org && x.name == this.topicObj.category
            ).map((x) => x.sameName);
            this.sameName = sameName[0]

            if(this.sameName == "Yes") {
                this.topicObj.institution = this.topicObj.category
                let subbb = this.allinsti
                    .filter((x) => x.name == this.topicObj.category && x.organization_name == this.org)
                    .map((x) => x.subjects_offered);
                this.subjectOptions = JSON.parse(subbb);
            }
            // let inst = this.allinsti.filter(x => x.available == "Yes" && x.category == this.topicObj.category).map(x => x.name);
            // this.institutionsarray = inst;
            

            // if (this.topicObj.category == "JAMB") {

            //     this.topicObj.institution = "JAMB";

            //      // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
            //     let unparsedSubjects = this.allinsti.filter(x => x.name == this.topicObj.institution && x.category == this.topicObj.category).map(x => x.subjects_offered);

            //     this.subjectOptions = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectOptions' to it
            // }
        },
        institutionChanged() {
            this.levelsarray = [] // Anytime user changes Institution, empty the levelsarray

            // If the selected category to be taken is undergraduate
            if (this.structure == "Section") {
                // Get the levels config Object for this particular institution under the undergraduate category
                // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
                let unparsedLevelConfig = this.allinsti.filter(x => x.category == this.topicObj.category && x.name == this.topicObj.institution && x.organization_name == this.org).map(x => x.levels_config);
                let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
        
                // Get the name of each level available in the levels config. It should return "['100', '200']" depending on the levels available in the Configurations Object
                this.levelsarray = parsedLevelConfig.map(x => x.name);
               

            } else {
                // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
                let unparsedSubjects = this.allinsti.filter(x => x.name == this.topicObj.institution && x.category == this.topicObj.category && x.organization_name == this.org).map(x => x.subjects_offered);
                this.subjectOptions = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectOptions' to it
            }
        },

        levelChanged() {
            this.coursesarray = []
             // Get the levels config Object for this particular institution under the undergraduate category
            // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
            let unparsedLevelConfig = this.allinsti.filter(x => x.category == this.topicObj.category && x.name == this.topicObj.institution && x.organization_name == this.org).map(x => x.levels_config);
            let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
            
            // Get the Chosen Level exact config Array.
            // To see output. Console.log(config) in development mode
            let config = parsedLevelConfig.filter(x => x.name == this.topicObj.level).map(x => x.config);
            // Now get the Courses from the courses Object of the Chosen level exact config Object
            let courses = config[0].filter(x => x.name == "courses").map(x => x.values);

            // Inject this Array into the general courses Array for Selection
            this.coursesarray = courses[0];
        },

        setTopic() {
            this.setloader();

            this.updateTopic(this.topicObj).then(() => {
                this.updated = true;
                this.updating = false;
            });
        },
        getForm() {
            return {
                institution: null,
                category: null,
                topicfor : null,
                level : null,
                topic: "",
                trackid: ""
            };
        },
        setloader() {
            this.updating = true;
        },
        proceed() {
            this.updating = true; // Set value of the data property 'proceeding' to true. This triggers the spinner to come up and also disables the proceed button
        },
        stopproceed() {
            this.updating= false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
        },

        ...mapActions("admin", ["updateTopic"]),
    },
    computed: {
        ...mapState({
            details: state => state.loginmaster.details,
            loggedin: state => state.loginmaster.loggedIn,
            topicforedit: state => state.admin.topicforedit[0],
            allinsti: (state) => state.admin.listinstitutions,
            fileimage: state => state.admin.quimageurl,
            Categories: state => state.admin.Categories,
            environ: state => state.loginmaster.environ
        }),
        leav() {
            return this.leaving;
        },
        substate(){
            return this.topicObj.topic.length == 0 || this.topicObj.institution == 'Post UTME' ? false : true
        }
    }
};
</script>

<style scoped>
.copyinline {
    background-color: #000000;
    color: white;
    display: inline-flex;
}

.copyicon {
    cursor: pointer;
}

.copier {
    position: absolute;
    left: -9999px;
}


.btn-sub {
    font-size: 18px;
    font-weight: bold;
    background-color: #00984a;
    color: white;
    cursor: pointer;
}

@media screen and (max-width: 768px) {
    .image-attachment {
        width: 100%;
        height: 200px;
    }
}

@media screen and (min-width: 768px) {
    .image-attachment {
        width: 100%;
        height: 300px;
    }
}
</style>
